import { Lines } from '../../models/line';

export class AddLines {
  static readonly type = '[LINE] add';
  constructor(public payload: Lines[]) {}
}

export class RemoveLines {
  static readonly type = '[LINE] remove';
  constructor() {
    /**/
  }
}
